import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import type { FieldRendererProps } from "./index";

export function LongTextField({ label, required, properties, disabled }: FieldRendererProps) {
  return (
    <div className="space-y-2">
      <Label>
        {label}
        {required && <span className="ml-1 text-destructive">*</span>}
      </Label>
      <Textarea
        placeholder={properties.placeholder ?? ""}
        defaultValue={properties.defaultValue ?? ""}
        disabled={disabled}
        rows={3}
      />
    </div>
  );
}
